import http from '@/services/http';

export interface MovementReport {
  start_date: string;
  end_date: string;
  total_moves: number;
  variboxes_moved: number;
  average_moves_per_varibox: number;
  daily_trend: Array<{ day: string; moves: number }>;
  most_moved_variboxes: Array<{
    varibox_id: string | null;
    serial_number: string;
    radex_identifier: string;
    moves: number;
    last_moved_at: string;
  }>;
  recent_movements: Array<{
    id: string;
    serial_number: string;
    radex_identifier: string;
    from_location: string | null;
    to_location: string;
    actor_name: string;
    moved_at: string;
    note: string | null;
  }>;
}

export async function getMovementReport(startDate: string, endDate: string) {
  const response = await http.get<MovementReport>('/api/reports/movements', {
    params: { start_date: startDate, end_date: endDate },
  });
  return response.data;
}

export async function exportMovementReport(startDate: string, endDate: string) {
  const response = await http.get<Blob>('/api/reports/movements.xlsx', {
    params: { start_date: startDate, end_date: endDate },
    responseType: 'blob',
  });
  return response.data;
}
